<ng-container *ngIf="!isBuyingWindow && !hasVariations">
  <ng-container *ngIf="enabled && !readonly">
    <div class="od-allocation-group--container">
      <div *ngIf="!isListView" class="label color--primary-grey">Allocation Group</div>

      <ng-container *ngIf="(fetchingAllocationInventory$ | async) !== true; else loading">
        <div *ngIf="filteredAllocationGroups$ | async; let allocations; else loading">

          <ng-select
            #select
            class="ng-select--custom searchable"
            [ngClass]="selectClass"
            [items]="allocations"
            bindValue="allocation_group_id"
            placeholder="Select Allocation Group"
            [searchable]="true"
            [typeahead]="searchSubject"
            (change)="onSelect($event)"
            [clearable]="false"
            [appendTo]="appendTo"
            dropdownPosition="bottom"
            [disabled]="disabled"
            [(ngModel)]="selectedInventoryAllocationId"
            [notFoundText]="(allocationsFailed$ | async) ? 'Could not load allocation groups' : 'No items found'"
            [typeToSearchText]="(allocationsFailed$ | async) ? 'Could not load allocation groups' : 'No items found'">
            <ng-template ng-label-tmp let-item="item">
              <span class="d-block font-weight-bold font-5 allocation-group-label">{{ labelForSelected(item) }}</span>
              <span *ngIf="hasAvailableQty(item)" class="d-block font-5">Available: {{ item.available_qty }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
                      <span class="d-block font-weight-bold font-6 allocation-group-label">
                          {{ item.allocation_group_label }}
                      </span>
              <span class="d-block font-6">Available: {{ item.available_qty }}</span>
            </ng-template>
          </ng-select>
        </div>
      </ng-container>
    </div>

  </ng-container>
  <ng-container *ngIf="enabled && readonly">
    <div class="ondemand-allocation readonly-view">
      <div class="label color--primary-grey">Allocation Group</div>
      <div class="font-weight-bold text-break-all">{{selectedAllocationGroupLabel}}</div>
    </div>
  </ng-container>
</ng-container>


<ng-template #loading>
    <div class="content-loader small mt-3">
        <div class="inline-loader"></div>
    </div>
</ng-template>

